export default __webpack_public_path__ + "static/media/skew.ebf7309a.png";